<div class="spinner-holder">
  <mat-spinner diameter="55"></mat-spinner>
</div>
